<div class="d-flex justify-content-between mt-2">

    
        <div class="d-flex align-items-center" *ngIf="viewRespected()">
            <i style="color: #66FF66;" class="fa-solid fa-circle fa-2x"></i>
        </div>
        <div class="d-flex align-items-center" *ngIf="!viewRespected()">
            <i style="color: #FE0000;" class="fa-solid fa-circle fa-2x"></i>
        </div>
</div>
